import { Dialog } from 'vant'
import store from '@/store'
export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$checkLogin', {
      value: function checkLogin() {
        const token = localStorage.getItem('user_tokenValue')
        if (!token) {
          // 直接执行授权逻辑，不显示确认弹窗
          const path = window.location.hash.split('#')[1]
          localStorage.setItem('user_path', path)
          store.dispatch('login/set_login_path', path)
          store.dispatch('login/jumpAuthAddress')
        }
      }
    })

    Object.defineProperty(Vue.prototype, '$clearCache', {
      value: function clearCache(isDirect) {
        store.dispatch('login/set_token_value', '')
        store.dispatch('login/set_user_info', null)
        localStorage.setItem('user_tokenValue', '')
        if (isDirect) {
          const path = window.location.hash.split('#')[1]
          localStorage.setItem('user_path', path)
          store.dispatch('login/set_login_path', path)
          store.dispatch('login/jumpAuthAddress')
          return
        }
        Vue.prototype.$checkLogin()
      }
    })
  }
}
